import React, { useEffect, useMemo } from 'react';

import { Codeowners } from '../consts/codeowners';
import { useChangeStep } from '../hooks/useChangeStep';
import { useServices } from '../hooks/useServices';
import { CartItem } from '../state/types';
import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';
import { getItemFromCart } from '../state/utils';
import { useToastController } from '../toast';
import { captureException } from '../utils/exception';

import { ScrollableContent } from './ScrollableContent';
import { ServiceCard } from './ServiceCard';

export const ServiceList = () => {
  const { dispatch, actions, state } = useOnlineBookingReducer();
  const { industry, subcategory, category, token, cart } = state;
  const { data } = useServices({ token });
  const { showToast } = useToastController();
  const { changeStep } = useChangeStep();

  const categories = data?.industries?.find((fetchedIndustry) => fetchedIndustry.uuid === industry?.uuid)?.categories;
  const selectedCategory = categories?.find((cat) => cat.uuid === category?.uuid);

  const services = useMemo(() => {
    const hasSubCategory = Boolean(subcategory);
    if (hasSubCategory) {
      return selectedCategory?.subcategories?.find((item) => item.uuid === subcategory?.uuid)?.services;
    }
    return selectedCategory?.services;
  }, [subcategory, selectedCategory]);

  const isOldCategorySelected = useMemo(
    () =>
      categories &&
      state.category &&
      !(categories ?? []).find((fetchedCategory) => fetchedCategory.uuid === state.category?.uuid),
    [categories, state.category]
  );

  useEffect(() => {
    if (isOldCategorySelected) {
      dispatch(actions.resetStep());
      const errorMessage = 'Selected category has changed, please pick another one.';

      captureException(new Error(errorMessage), Codeowners.CUSTOMER_INTAKE);
      showToast(errorMessage);
    }
  }, [actions, dispatch, isOldCategorySelected, showToast]);

  return (
    <ScrollableContent>
      {services?.map((service) => (
        <ServiceCard
          key={service.uuid}
          title={service.name}
          price={service.price}
          image={service.image}
          description={service.description}
          onClick={() => {
            dispatch(actions.selectService(service));
            changeStep('service-details');
          }}
          isActive={Boolean(cart.find((cartItem: CartItem) => getItemFromCart(cartItem).uuid === service.uuid))}
        />
      ))}
    </ScrollableContent>
  );
};
